export enum HomeWorkIdentifier {
  HOME,
  WORK,
}

export enum LayerTypeEnum {
  Scatterplot = "Households",
  Heatmap = "Heatmap",
  Hexagon = "Hexagon",
}

export enum MapStyleEnum {
  Light = "Light",
  Dark = "Dark",
}
